import { defineMessages } from 'react-intl';

import type { PaymentError } from '@/lib/types';

import { commonErrorCodeMessages, type FormattedError } from './common';

const errors = defineMessages({
  refused: {
    id: `paymentMethod.errorPaymentRefusedCembra`,
    defaultMessage:
      'Sorry, you are not eligible for financing. Please choose another payment method.',
  },
});

export const getCembraErrorCodeMessage = (
  error: FormattedError<PaymentError>,
) => {
  switch (error.code) {
    case 'Refused':
      return errors.refused;
    default:
      return error.message
        ? error.message
        : commonErrorCodeMessages.genericPaymentErrorWithoutMessage;
  }
};
